import { Component, OnInit, ViewChild } from "@angular/core";
import { isBs3 } from "ngx-bootstrap/utils";
import { IDropdownSettings } from "ng-multiselect-dropdown";
import * as _ from "lodash";
import * as moment from "moment";
import { ModalDirective } from "ngx-bootstrap/modal";
// import { Module } from 'ag-grid-community';
import { Module, AllCommunityModules } from "@ag-grid-community/all-modules";
import { ConstantService } from "../../services/constant.service";
import { Router } from "@angular/router";
import { ViewRendererComponent } from "../../renderer/view-renderer.component";
import { ApiService } from "../../services/api.service";
import { GrievanceService } from "../../services/grievance.services";
import { EditButtonRendererComponent } from "../../renderer/edit-button-renderer.component";
import { DeleteButtonRendererComponent } from "../../renderer/delete-button-renderer.component";
import { ExportAsService, ExportAsConfig } from "ngx-export-as";
import { ExcelService } from "../../services/export-excel.service";

@Component({
  selector: "app-salary",
  templateUrl: "./salary.component.html",
})
export class SalaryComponent implements OnInit {
  @ViewChild('deleteDataModal') public deleteDataModal: ModalDirective;
  @ViewChild("deleteBulkComplainModal")
  public deleteBulkComplainModal: ModalDirective;
  @ViewChild("updateComplaintModal")
  public updateComplaintModal: ModalDirective;
  isBs3 = isBs3();
  public gridApi;
  public gridColumnApi;
  public gridOptions;
  public modules: Module[] = AllCommunityModules;
  public context;
  public frameworkComponents;
  public defaultColDef;
  public columnDefs;
  public permission;
  public rowClassRules;
  public rowSelection;
  _ = _;
  moment = moment;
  selectedYear = moment().format("YYYY");
  selectedMonth = moment().format("MMM");

  dropdownList = [];
  selectedUser: any = {};
  dropdownSettings: IDropdownSettings = {};
  filterParams = {
    dateRange: [new Date(), new Date()],
    date: new Date(),
    project: "",
    punch_slot: "",
    username: "",
    month: moment().subtract(1, "month").format("MM"),
    year: moment().format("YYYY"),
  };

  bsRangeValue: Date[];
  paginaton = {
    totalItems: 0,
    currentPage: 1,
    maxSize: 100,
  };

  years = [
    moment().format("YYYY"),
    moment().subtract(1, "years").format("YYYY"),
    moment().subtract(2, "years").format("YYYY"),
    moment().subtract(3, "years").format("YYYY"),
    moment().subtract(4, "years").format("YYYY"),
  ];
  months = this.constantService.MONTHS;

  alert = {
    type: "info",
    msg: "",
    timeout: 3000,
  };
  maxDate = new Date();

  exportAsConfig: ExportAsConfig = {
    type: "pdf", // the type you want to download
    elementIdOrContent: "tableToPrint", // the id of html/table element,
    options: {
      // html-docx-js document options

      jsPDF: {
        orientation: "landscape",
      },
      margins: {
        top: "40px",
        bottom: "40px",
        left: "40px",
        right: "40px",
      },
    },
  };

  fields = ['employee_id', 'employee_name', 'phone_number', 'employee_location', 'designation', 'gender', 'date_of_joining', 'date_of_birth', 'esic_account_no', 'sa_policy_no', 'uan', 'pan', 'bank_account_no', 'ifsc_code', 'bank_name', 'status', 'calender_days', 'paid_days', 'lop_days', 'month', 'year', 'base_salary', 'hra', 'transport_allowance', 'communication_allowance', 'mobile_allowance', 'special_allowance', 'pf_employer', 'performance_incentive', 'education_allowance', 'total_earning', 'pf_deduction', 'pf_employer_deduction', 'group_insurance_deduction', 'tds_deduction', 'prof_tax_deduction', 'gst_deduction', 'service_charge_deuction', 'excess_pay_adjustment', 'generic_advance', 'tds_due_adjustment', 'total_deduction', 'net_salary', 'total_ctc_without_tax', 'total_ctc_with_tax'];
  username = "";
  selectedComplaint: any = {};
  selectedData: any = {};
  exportingCsv = false;
  constructor(
    private constantService: ConstantService,
    private apiService: ApiService,
    private grievanceService: GrievanceService,
    public router: Router,
    private exportAsService: ExportAsService,
    private excelService: ExcelService
  ) {
    this.permission = this.constantService.getCookies().PERMISSION;
    let permissionArray = this.permission.split("");
    this.username = this.constantService.getCookies().USERNAME;

    this.context = { componentParent: this };
    this.defaultColDef = {
      sortable: true,
      filter: true,
      resizable: true,
      floatingFilter: true,
      filterParams: { buttons: ["clear"] },
    };

    this.frameworkComponents = {
      viewRenderer: ViewRendererComponent,
      editButtonRenderer: EditButtonRendererComponent,
      deleteButtonRenderer: DeleteButtonRendererComponent,
    };

    this.rowSelection = "multiple";
    this.columnDefs = [];

    _.each(this.fields, (field) => {
      this.columnDefs.push({
        headerName: this.convertLabel(field),
        field: field,
        width: 120,
      });
    });
    this.columnDefs.push(
      {
        headerName: 'Pay Slip', field: 'secret_key',
        cellRenderer: (invNum) => {
          console.log(invNum);
          return `<a href="https://api.foundryconsultancy.in/report/pay_slip.php?id=${invNum.value}" target="_blank" >View</a>`
        }, width: 100, filter: false, resizable: true, sortable: false, cellClass: ['text-center'], pinned: 'right'
      },
    );

    if (_.includes(permissionArray, 'd')) {
      this.columnDefs.push(
        { headerName: 'Delete', field: 'value', cellRenderer: 'deleteButtonRenderer', colId: 'params1', width: 60, filter: false, resizable: true, sortable: false, pinned: 'right', cellClass: ['text-center'] },
      )
    }
  }

  convertLabel(label: string) {
    return label.replace(/_/g, " ").toUpperCase();
  }

  ngOnInit(): void {
    this.dropdownSettings = {
      singleSelection: false,
      idField: "item_id",
      textField: "item_text",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 3,
      allowSearchFilter: true,
    };
    console.log(this.grievanceService.getSelectedDateRange());
    if (this.grievanceService.getSelectedDateRange().length > 0) {
      this.filterParams.dateRange =
        this.grievanceService.getSelectedDateRange();
    }
    this.searchReport();
    this.getResources();
  }
  records = [];
  paginatedRecord = [];
  searchReport() {
    this.records = [];
    let queryString =
      "* FROM salary_structure WHERE month = '" +
      this.filterParams.month +
      "' AND year = '" +
      this.filterParams.year +
      "'";
    console.log(queryString);
    this.apiService.getCustomData(btoa(queryString)).subscribe((data: any) => {
      this.records = data;
    });
  }

  monthData: any = {
    working_days: moment(
      '"' + this.filterParams.year + "-" + this.filterParams.month,
      "YYYY-MM"
    ).daysInMonth(),
    total_days: moment(
      '"' + this.filterParams.year + "-" + this.filterParams.month,
      "YYYY-MM"
    ).daysInMonth(),
  };
  getMonthDays() { }

  pageChanged(event): void {
    this.paginaton.currentPage = event.page;
    this.paginatedRecord = this.records.slice(
      (this.paginaton.currentPage - 1) * this.paginaton.maxSize,
      this.paginaton.currentPage * this.paginaton.maxSize
    );
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  methodFromParent(userData) {
    this.selectedData = userData;
    console.log(this.selectedData, userData.action);
    if (userData.action === 'edit') {
    }
    if (userData.action === 'delete') {
      this.deleteDataModal.show();
    }


  }

  onBtnExport() {
    var params = this.getParams();
    if (params.suppressQuotes || params.columnSeparator) {
      alert(
        "NOTE: you are downloading a file with non-standard quotes or separators - it may not render correctly in Excel."
      );
    }
    this.gridApi.exportDataAsCsv(params);
    setTimeout(() => {
      this.exportingCsv = false;
    }, 2000);
  }

  getParams() {
    let reportDate =
      "Complain List " +
      moment(this.filterParams.dateRange[0])
        .startOf("day")
        .format("YYYY-MM-DD") +
      " to " +
      moment(this.filterParams.dateRange[1]).endOf("day").format("YYYY-MM-DD");
    return {
      suppressQuotes: "",
      columnSeparator: "",
      customHeader: reportDate,
      customFooter: "",
      fileName:
        "Complain_List_" +
        moment(this.filterParams.dateRange[0]).format("YYYY-MM-DD") +
        "_to_" +
        moment(this.filterParams.dateRange[1])
          .endOf("day")
          .format("YYYY-MM-DD"),
    };
  }

  userList: any = [];
  projectList: any = [];
  getResources() {
    let getUser = this.apiService.getData("employees");
    let getProject = this.apiService.getData("project");
    let that = this;
    Promise.all([getUser, getProject]).then((resp) => {
      that.userList = resp[0];
      that.projectList = resp[1];
    });
  }

  punch_slot: any = [];
  projectUsers: any = [];
  selectProject(project) {
    console.log(project);
    let projectMatch = _.filter(this.projectList, { name: project });
    console.log(projectMatch);
    if (projectMatch.length > 0 && projectMatch[0].name) {
      if (projectMatch[0].punch_slot) {
        let slot = projectMatch[0].punch_slot.split(",");
        this.punch_slot = slot;
      }

      this.projectUsers = _.filter(this.userList, (user: any) => {
        return user.project === projectMatch[0].name;
      });
      console.log(this.projectUsers);
    }
  }

  exportPdf() {
    this.exportAsService
      .save(this.exportAsConfig, "Complain_Report")
      .subscribe(() => { });
  }

  onItemSelect(e) { }
  onItemDeSelect(e) { }
  onSelectAll(e) { }

  excelExportData: any = [];

  ClickExport(): void {
    let complainDate = "";
    complainDate =
      "Monthly Attendance Register  (" +
      moment(this.filterParams.date).format("YYYY-MM-DD") +
      ")";

    let fileData = {
      fileName:
        "MonthlyAttendance Report " +
        moment(this.filterParams.date).format("YYYY_MM_DD"),

      reportDate: moment().format("YYYY-MM-DD"),
      dateFilter: complainDate,
    };

    // this.excelService.generateExcel(this.excelExportData, fileData);
  }

  arrangeDataForExport(records) {
    let data: any = [];
    _.each(records, (r) => {
      data.push([r.username, r.fullName, r.date, r.location, r.latlang]);
    });
    this.excelExportData = data;
  }


  deleteData() {
    this.apiService.deleteDetail('salary_structure', 'srl_no', [this.selectedData.srl_no]).subscribe((resp) => {
      this.searchReport();
      setTimeout(() => {
        this.deleteDataModal.hide();
        this.alert.msg = '';
      }, 1000)
    })
  }

}
